import React from 'react';
import './about.css';

function About() {
  return (
    <div id="about-container">
      <h1>Sobre Nós</h1>
      <hr />
      <div className="cards-container">
        <div className="card">
          <div className="card-overlay">
            <h2>Bárbara Lepore</h2>
            <p>Arquiteta e Urbanista, Técnica em Edificações, apaixonada por interiores, materiais naturais, tecnologia e inovação nos projetos.</p>
          </div>
        </div>
        <div className="card2">
          <div className="card-overlay">
            <h2>Fernando Lepore</h2>
            <p>Projetista e diretor, apaixonado pela arquitetura, detalhes técnicos, gerenciamento e obras, com muitos anos de experiência na construção civil.</p>
          </div>
        </div>
      </div>

      {/* Seção sobre a empresa */}
      <div className="about-company">
        <h2>Sobre a Belive Arquitetura</h2>
        <p>
        Somos especialistas em arquitetura e decoração, dedicados a criar espaços inovadores e criativos que inspirem e encantem. Nossa abordagem única combina funcionalidade e beleza para transformar ambientes em experiências memoráveis.
        </p>
      </div>

      {/* Seção de depoimentos */}
      <div className="testimonials">
        <h2>Depoimentos de Clientes</h2>
        <div className="testimonial">
          <p>"O comprometimento e a atenção aos detalhes nos surpreenderam. Recomendamos sem reservas."</p>
          <span>— Profissionalismo Inigualável</span>
        </div>
        <div className="testimonial">
          <p>"A Believe Arquitetura criou um ambiente que refletiu exatamente a essência de quem somos."</p>
          <span>— Experiência Memorável</span>
        </div>
      </div>
    </div>
  );
}

export default About;
